var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 21L10.3914 14.7187C10.3585 14.6665 10.3128 14.6234 10.2587 14.5935C10.2046 14.5636 10.1438 14.548 10.082 14.548C10.0202 14.548 9.95945 14.5636 9.90534 14.5935C9.85124 14.6234 9.80559 14.6665 9.77266 14.7187L7.81328 17.6625C7.77843 17.7142 7.73123 17.7564 7.67594 17.7853C7.62066 17.8142 7.55905 17.8289 7.49668 17.8279C7.43431 17.827 7.37316 17.8105 7.31877 17.78C7.26437 17.7495 7.21845 17.7059 7.18516 17.6531L6.27578 16.2375C6.2406 16.1853 6.19313 16.1425 6.13755 16.113C6.08198 16.0834 6.01999 16.0679 5.95703 16.0679C5.89408 16.0679 5.83209 16.0834 5.77651 16.113C5.72093 16.1425 5.67346 16.1853 5.63828 16.2375L2.58203 21H14.582Z",
    fill: "#FF3333",
    stroke: "#FF3333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 3V8.25H19.832",
    fill: "#FF3333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 3V8.25H19.832",
    stroke: "#FF3333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 21H19.082C19.2809 21 19.4717 20.921 19.6124 20.7803C19.753 20.6397 19.832 20.4489 19.832 20.25V8.25L14.582 3H5.58203C5.38312 3 5.19235 3.07902 5.0517 3.21967C4.91105 3.36032 4.83203 3.55109 4.83203 3.75V12.75",
    stroke: "#FF3333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.96c26a236c819869b6db4e6262bdd43c.svg";
export { ForwardRef as ReactComponent };